import { normalizeGridColumnProps } from '@zoryn/components/grid/src/column/seq-column'
import type { GridColumnProps } from '../types'

/**
 * 树表默认不插入序号列（对齐 vxe-table 树形展示）；显式声明 seq 时仍保留。
 */
export function normalizeGridTreeColumnProps(
  columns: GridColumnProps[]
): GridColumnProps[] {
  if (columns.some((col) => col.type === 'seq')) {
    return normalizeGridColumnProps(columns)
  }
  return columns.filter((col) => col.type !== 'seq')
}
